import { Component, Input, ViewChild, TemplateRef, ViewContainerRef, AfterViewInit, OnDestroy, EmbeddedViewRef } from '@angular/core';

@Component({
    selector: "crew-nested-list",
    template: require('./nested-list.component.html')
})
export class NestedList implements AfterViewInit, OnDestroy {

    private headerViewRef: EmbeddedViewRef<any>;

    constructor() {
        // default values
        this.itemDisplayName = "Name";
        this.nestingLevel = 0;
    }

    @Input()
    headerItem: any;

    @Input()
    headerDisplayName: string;

    @Input()
    headerDetailsState: string;

    @Input()
    headerTemplate: TemplateRef<any>;

    @Input()
    headerLevel: number;

    @Input()
    underlineHeader: boolean;

    @Input()
    items: any[];

    @Input()
    getChildrenFuncs: ((item: any) => ChildInfo)[];

    @Input()
    itemDisplayName: string;

    @Input()
    itemDetailsState: string;

    @Input()
    itemTemplate: TemplateRef<any>;

    @Input()
    getIsActive: (item: any) => boolean;

    @Input()
    searchText: string;

    @Input()
    showInactive: boolean;

    @Input()
    nestingLevel: number;

    ngAfterViewInit(): void {
        if (this.hasHeaderItem && this.hasHeaderTemplateToUse) {
            this.containerForHeader.clear();
            this.headerViewRef = this.containerForHeader.createEmbeddedView(this.headerTemplateToUse, { $implicit: this.headerItem[this.headerDisplayName] });
        }
    }

    ngOnDestroy(): void {
        if (this.headerViewRef) {
            this.headerViewRef.destroy();
        }
    }

    get hasHeaderItem(): boolean {
        return !!this.headerItem;
    }

    get hasItemsToShow(): boolean {
        return !!this.itemsToShow.length;
    }

    get itemsToShow(): any[] {
        return this.hasItems ?
            this.items.filter(item => this.isMatch(item, this.itemDisplayName, this.getChildrenFuncs, this.getIsActive)) :
            []
    }

    get leftPaddingPx(): string {
        return this.nestingLevel > 1 ? '16px' : '0px';
    }

    private get hasItems(): boolean {
        return this.items && !!this.items.length;
    }

    private isMatch(item: any, itemDisplayName: string, getChildrenFuncs: ((item: any) => ChildInfo)[], getIsActive: (item: any) => boolean): boolean {
        return this.isActiveMatch(item, getIsActive) && (!this.searchText || this.isSearchTextMatch(item[itemDisplayName]) || this.anyChildIsMatch(item, getChildrenFuncs));
    }

    private isActiveMatch(item: any, getIsActive: (item: any) => boolean): boolean {
        if (!getIsActive) {
            getIsActive = (item: any) => item.Active;
        }

        return this.showInactive || getIsActive(item);
    }

    private isSearchTextMatch(name: string): boolean {
        return name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
    }

    private anyChildIsMatch(item: any, getChildrenFuncs: ((item: any) => ChildInfo)[]): boolean {
        if (!getChildrenFuncs.length) {
            return false;
        }

        const [getChildrenFunc, ...remainingGetChildrenFuncs] = getChildrenFuncs;
        const { children, childDisplayName, getIsActive } = getChildrenFunc(item);

        return children.some(child => this.isMatch(child, childDisplayName, remainingGetChildrenFuncs, getIsActive));
    }

    private get headerTemplateToUse(): TemplateRef<any> {
        return this.hasInputHeaderTemplate ? this.headerTemplate : (this.hasHeaderTemplateByNumber ? this.headerTemplateByNumber : null);
    }

    private get hasHeaderTemplateToUse(): boolean {
        return !!this.headerTemplateToUse;
    }

    private get hasInputHeaderTemplate(): boolean {
        return !!this.headerTemplate;
    }

    private get hasHeaderTemplateByNumber(): boolean {
        return !!this.headerTemplateByNumber;
    }

    private get headerTemplateByNumber(): TemplateRef<any> {
        switch (this.headerLevel) {
            case 1:
                return this.header1;
            case 2:
                return this.header2;
            case 3:
                return this.header3;
            case 4:
                return this.header4;
            default:
                return this.header4;
        }
    }

    @ViewChild("headerContainer", { read: ViewContainerRef }) containerForHeader: ViewContainerRef;

    @ViewChild('h1Header') header1: TemplateRef<any>;
    @ViewChild('h2Header') header2: TemplateRef<any>;
    @ViewChild('h3Header') header3: TemplateRef<any>;
    @ViewChild('h4Header') header4: TemplateRef<any>;
}

export interface ChildInfo {
    headerTemplate?: TemplateRef<any>;
    headerLevel?: number;
    underlineHeader?: boolean;
    children: any[];
    childDisplayName: string;
    childDetailsState: string;
    childTemplate?: TemplateRef<any>;
    getIsActive?: (item: any) => boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/nested-list.component.ts